export default "__VITE_ASSET__CUbZGHFg__"